import { render, staticRenderFns } from "./CanalWeb.vue?vue&type=template&id=d432c7ae&lang=pug"
import script from "./CanalWeb.vue?vue&type=script&lang=js"
export * from "./CanalWeb.vue?vue&type=script&lang=js"
import style0 from "./CanalWeb.vue?vue&type=style&index=0&id=d432c7ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports